import store from './../../../../store';

import * as config from './config';
import rootSaga from './sagas';

store.injectSaga(config.domain, rootSaga);